
import {of,  Observable } from 'rxjs';

import {map, flatMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettingsService, BaseService, ServiceManager } from 'iui-iconectiv-lib';

export class Account {
  public updatedBy: string;
  public updateDateTime: Date;
}


export class Company {
  public _id: string;
  public accountId: number;
  public companyId: string;
  public companyName: string;
}





/**
 * A choice for a select control.
 */
export class SelectChoice {
  constructor(public idx: number, public key: string, public label: string, public disabled = false, public selected = false) {

  }
}




export class ContactType extends SelectChoice {
  public required: boolean;
}

export class AttachmentPath {
  public idx: number;
  public path: string;
  public accept: string;
  public label: string;

  /**
   * An attachment of this type can be added for campaigns with these address types.
   */
  public addressTypes: string[];
}




export class CustomerSupportHoliday {
  holidayDateTime: Date;
  name: string;
}
export class CustomerSupportScheduledDowntime {
  startDateTime: Date;
  endDateTime: Date;
}

export class CustomerSupportContact {
  hours: string;
  phone: string;
  email: string;
}

export class CustomerSupportInfo {
  contact: CustomerSupportContact;
  scheduledDowntimeList: CustomerSupportScheduledDowntime[];
  holidayList: CustomerSupportHoliday[];
}

export class RefdataResponse {
  status: string;
  otherCompanies: Company[];
  messagetransportoptions: SelectChoice[];
  programtypes: SelectChoice[];
  advertisingmedium: SelectChoice[];
  contacttype: ContactType[];
  attachmentpaths: AttachmentPath[];
  customersupport: CustomerSupportInfo;
  messagedirection: SelectChoice[];
  accounttype: SelectChoice[];
  addressType: SelectChoice[];
  contentType: SelectChoice[];
  umidType: SelectChoice[];
  vapType: SelectChoice[];
  contentrating2: SelectChoice[];
  contentrating4: SelectChoice[];
  reportTypes: SelectChoice[];
  region: SelectChoice[];
  faqUrl: string;
  customerSupportUrl: string;
}





@Injectable()
export class RefdataService extends BaseService {

  refdata: RefdataResponse;
  obs: Observable<RefdataResponse>;

  constructor(serviceManager: ServiceManager,
    private http: HttpClient,
    private appSettings: AppSettingsService) {
    super(serviceManager);
  }

  public refresh() {
    this.doGet();
  }

  doGet(): Observable<RefdataResponse> {
    this.obs = this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + '/api/refdata';
      return this.http.get(url, { 'responseType': 'text' }).pipe(map(res => {
        const rsp = this.parseToType<RefdataResponse>(res);
        if ('success' !== rsp.status) {
          console.warn('refdata response ' + JSON.stringify(rsp));
          this.refdata = rsp;
        }
        else {
          this.refdata = rsp;
          return this.refdata;
        }
      }));
    })));
    return this.obs;
  }

  public getRefdata(): Observable<RefdataResponse> {
    if (this.refdata) {
      return of(this.refdata);
    }
    else if (this.obs) {
      return this.obs;
    }
    else {
      return this.doGet();
    }
  }





  /* private filteredReasons(usage: string, refdata: RefdataResponse): StatusChangeReason[] {
    return refdata.reasons.filter(r => {
      return r.usage.findIndex(s => s === usage) >= 0;
    });
  } */

  /* public getReasons(usage?: string): Observable<SelectChoice[]> {
    if (this.refdata) {
      return Observable.of(this.filteredReasons(usage, this.refdata));
    }
    else {
      return Observable.create(observer => {
        this.getRefdata().subscribe(rd => {
          if (usage) {
            observer.next(this.filteredReasons(usage, rd));
          }
          else {
            observer.next(rd.reasons);
          }
          observer.complete();
        },
          error => {
            observer.error(error);
          });
      }).share();
    }
  }
 */


  public getSelectChoices(dataType: string): Observable<SelectChoice[]> {
    if (this.refdata) {
      return of(this.refdata[dataType]);
    }
    else {
      return Observable.create(observer => {
        this.getRefdata().subscribe(
          rd => {
            observer.next(rd[dataType]);
            observer.complete();
          },
          error => {
            observer.error(error);
          });
      }).share();
    }
  }

}
